/**
 * Inventory section routes and nav helpers (shared by Layout + InventoryLayout).
 */

export const PATH_CERTIFIED = '/inventory/certified';
export const PATH_FANCY = '/inventory/fancy';
export const PATH_LOTS = '/inventory/lots';
export const PATH_REQ_CERTIFIED = '/inventory/requirements/certified';
export const PATH_REQ_LOTS = '/inventory/requirements/lots';
export const PATH_REQUIREMENTS = '/inventory/requirements';

export const INVENTORY_TAB_PATHS = [PATH_CERTIFIED, PATH_FANCY, PATH_LOTS];

/**
 * @param {string} pathname
 * @returns {'certified'|'fancy'|'lots'|'reqCertified'|'reqLots'}
 */
export function matchInventoryPanel(pathname) {
  if (pathname.startsWith(PATH_REQ_LOTS)) return 'reqLots';
  if (pathname.startsWith(PATH_REQ_CERTIFIED)) return 'reqCertified';
  if (pathname.startsWith(PATH_LOTS)) return 'lots';
  if (pathname.startsWith(PATH_FANCY)) return 'fancy';
  if (pathname.startsWith(PATH_CERTIFIED)) return 'certified';
  return 'certified';
}

/**
 * @param {boolean} canSeeRequirements
 * @returns {{ key: string, path: string, labelKey: string }[]}
 */
export function buildInventorySubItems(canSeeRequirements) {
  const items = [
    { key: 'certified', path: PATH_CERTIFIED, labelKey: 'inventory.certifiedDiamonds' },
    { key: 'fancy', path: PATH_FANCY, labelKey: 'inventory.fancyColors' },
    { key: 'lots', path: PATH_LOTS, labelKey: 'inventory.nonCertifiedDiamonds' },
  ];
  if (canSeeRequirements) {
    items.push(
      { key: 'reqCertified', path: PATH_REQ_CERTIFIED, labelKey: 'inventory.requirementsCertified' },
      { key: 'reqLots', path: PATH_REQ_LOTS, labelKey: 'inventory.requirementsLots' },
    );
  }
  return items;
}

/**
 * @param {string} pathname
 * @param {string} itemPath
 */
export function isInventorySubItemSelected(pathname, itemPath) {
  return pathname === itemPath || pathname.startsWith(`${itemPath}/`);
}

/**
 * @param {string} pathname
 * @param {boolean} canSeeRequirements
 */
export function shouldBlockRequirementsPath(pathname, canSeeRequirements) {
  return pathname.startsWith(PATH_REQUIREMENTS) && !canSeeRequirements;
}

/**
 * Redirect bare /inventory/requirements to a concrete child route.
 * @param {string} pathname
 * @param {boolean} canSeeRequirements
 * @returns {string|null}
 */
export function resolveBareRequirementsRedirect(pathname, canSeeRequirements) {
  if (pathname !== PATH_REQUIREMENTS) return null;
  return canSeeRequirements ? PATH_REQ_CERTIFIED : PATH_CERTIFIED;
}

/**
 * @param {'certified'|'lots'|'reqCertified'|'reqLots'} panel
 */
export function isRequirementsPanel(panel) {
  return panel === 'reqCertified' || panel === 'reqLots';
}
